// Смена «переезжает» в 06:00 по Москве — совпадает с сервером
// (finance/views.py: BUSINESS_DAY_OFFSET_HOURS). До 6 утра «сегодня» = ещё вчера.
export const BUSINESS_DAY_OFFSET_HOURS = 6;

// Деловой день в формате YYYY-MM-DD:
// берём московскую календарную дату момента «сейчас минус 6 часов».
export function businessTodayISO() {
    const shifted = new Date(Date.now() - BUSINESS_DAY_OFFSET_HOURS * 3600 * 1000);
    return shifted.toLocaleDateString('en-CA', { timeZone: 'Europe/Moscow' }); // YYYY-MM-DD
}

// Тот же деловой день как локальный Date на полночь —
// удобно для арифметики недели/месяца.
export function businessToday() {
    const [y, m, d] = businessTodayISO().split('-').map(Number);
    return new Date(y, m - 1, d);
}